import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

//components
import {Button as $Button} from 'components/Button';

const stylesConfig = {
  desktop: {
    btnHeight: '56px !important',
    iconSize: 24,
    leftLaneWidth: 56
  },
  mobile: {
    btnHeight: '56px !important',
    iconSize: 16,
    leftLaneWidth: 48
  }
};

export const StyledIcon = styled.div.attrs(p => ({
  size: stylesConfig[p.device].iconSize
}))``;

export const ButtonInner = styled.div`
  display: flex;
  height: 56px;
`;

export const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left: ${p => `calc(-1 * ${stylesConfig[p.device].leftLaneWidth}px / 2)`};
  font-weight: 400;
  letter-spacing: 0;

  @media (max-width: 373px) {
    left: 0px;
  }
`;

export const Left = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${p => stylesConfig[p.device].leftLaneWidth}px;
`;

export const StyledButton = styled($Button).attrs({
  design: 'solid-cool'
})`
  height: ${p => stylesConfig[p.device].btnHeight};
`;
